import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IPreviewLogicPageSurveyState } from 'types/previewCampaign';
// import { mockData } from 'pages/admin/survey/mock-data';

const initialState: IPreviewLogicPageSurveyState = {
    me: {
        id: '',
        type: '',
        creator: false,
    },
    surveyState: {
        answerable: false,
        title: '',
    },
    question_pages: [],
    capturePerformanceTimeStamp: [],
    capturePerformanceTimeByQuestion: {},
};
const previewLogicPageSurveySlice = createSlice({
    name: 'previewLogicPageSurvey',
    initialState,
    reducers: {
        setMe: (
            state,
            action: PayloadAction<{
                id: string;
                type: string;
                creator: boolean;
            }>
        ) => {
            state.me = {
                ...state.me,
                ...action.payload,
            };
        },
        setSurveyState: (
            state,
            action: PayloadAction<{
                answerable: boolean;
            }>
        ) => {
            state.surveyState = {
                ...state.surveyState,
                ...action.payload,
            };
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setListQuestion: (state, action: PayloadAction<any[]>) => {
            state.question_pages = action.payload;
        },
        captureTimeStamp: (state) => {
            state.capturePerformanceTimeStamp.push(performance.now());
        },
        resetCaptureTimeStamp: (state) => {
            state.capturePerformanceTimeStamp = [];
        },
    },
});

export const {
    setMe,
    setSurveyState,
    setListQuestion,
    captureTimeStamp,
    resetCaptureTimeStamp,
} = previewLogicPageSurveySlice.actions;

export default previewLogicPageSurveySlice.reducer;
